import axios from "axios";
import {BASE_API_URL} from "../../app/AppConfig";
import {AssociatedProduct, ProductCatalog} from "../Entity/Product";
import {LocalParams} from "../../components/LocalParams";
import {Brand} from "../Entity/Brand";

export async function getProductsRep(
  locale: string,
  page: number,
  itemsPerPage: number,
  groupCode: string,
  filterCode: string[] | string,
  filters: any,
  isEndOfStock: boolean
): Promise<ProductCatalog> {
  try {
    const params = new URLSearchParams();
    // Ajout des paramètres globaux
    if (page) params.append("page", page.toString());
    if (locale) params.append("locale", locale);
    if (itemsPerPage) params.append("itemsPerPage", itemsPerPage.toString());

    // Gestion dynamique des taxons (groupCode et filterCode)
    if (groupCode && filterCode) {
      if (Array.isArray(filterCode)) {
        params.set(groupCode, filterCode.join(";"));
      } else {
        params.set(groupCode, filterCode);
      }
    }

    // Ajout des autres filtres
    if (filters) {
      Object.values(filters).forEach((filter: any) => {
        if (
          filter.index &&
          filter.values?.length > 0 &&
          filter.index !== groupCode // ✅ empêche le doublon
        ) {
          params.append(filter.index, filter.values.join(";"));
        }
      });
    }

    if (isEndOfStock) {
      params.append("isEndOfStock", "true");
    }

    const userToken = LocalParams.getItem("token");
    const response = await axios.get<ProductCatalog>(
      `${BASE_API_URL}/catalog-product?${params.toString()}`,
      userToken ? { headers: { Authorization: `Bearer ${userToken}` } } : undefined
    );

    return response.data;
  } catch (err: any) {
    throw {
      code: err.response?.data?.code || "UNKNOWN_ERROR",
      message: err.response?.data?.message || "An unknown error occurred",
    };
  }
}

export async function getAssociatedProductsRep(productCode: string, locale: string): Promise<AssociatedProduct> {
  try {
    const response = await axios.get<AssociatedProduct>(
      `${BASE_API_URL}/associated-products?locale=${locale}&productCode=${productCode}`,
    );
    return response.data;
  } catch (err:any) {
    throw {code: err.response.data.code, message: err.response.data.message }
  }
}

export async function getProductsPromotionsBannerTextsRep(): Promise<string[]> {
  try {
    const response = await axios.get<string[]>(
      `${BASE_API_URL}/active-promotions`,
    );
    return response.data;
  } catch (err:any) {
    throw {code: err.response.data.code, message: err.response.data.message }
  }
}

export async function getBrandInfoRep(brandName: string, locale: string): Promise<Brand> {
  try {
    const response = await axios.get<Brand>(
      `${BASE_API_URL}/${locale}/brand/${brandName}`,
    );
    return response.data;
  } catch (err:any) {
    throw {code: err.response.data.code, message: err.response.data.message }
  }
}
